export enum MessageType {
  SAVED,
  DELETED,
  ERROR
}
